// extracted by mini-css-extract-plugin
export var button = "_l2-0";
export var donut = "_l2-1";
export var donutFill = "_l2-3";
export var donutTrack = "_l2-2";